<template>
  <div>
    <div style="text-align: center; padding: 40px">
      <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
    </div>
    <!-- <component :is="showComponent" v-else /> -->
  </div>
</template>
<script>
  // import ShowSurvey from './detail.vue'
  // import ShowEvaluation from '../test/do.vue'
  import store from '@/store/index'
  import { Toast } from 'vant'
  import qs from 'qs'
  export default {
    components: {
      // ShowSurvey,
      // ShowEvaluation,
    },
    data() {
      return {
        // showComponent: 'ShowSurvey',
        loading: true,
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        const query = this.$route.query
        const id = this.$route.params.id
        query.id = id
        const h5url = await store.getters['system/getH5Url']
        const jumpUrl = `${h5url}home/#/survey/dispatch/index?${qs.stringify(
          query
        )}`
        window.location.href = jumpUrl
        // console.log(query, jumpUrl)
        // store
        //   .dispatch('survey/GetByDispatchIds', {
        //     dispatchIds: [this.$route.params.id],
        //   })
        //   .then((data) => {
        //     const { Code, Data } = data
        //     if (Code === 0) {
        //       const detail = Data[0]
        //       if (detail.SurveyType === 1) {
        //         this.showComponent = 'ShowSurvey'
        //       } else {
        //         this.showComponent = 'ShowEvaluation'
        //       }
        //       this.loading = false
        //     } else {
        //       Toast('获取问卷失败，请稍后再试')
        //     }
        //   })
        //   .catch((e) => {
        //     Toast(e.Message || '获取问卷失败，请稍后再试')
        //   })
      },
    },
  }
</script>
